/**
 * Application routes as template
 * @see interpolate function to inject params
 */
export enum Route {
    LOGIN = "/login",
    RESET_PASSWORD = "/reset-password",
    HOME = "/",
    CLASSROOM_TEMPLATE = "/classroom-template",

    CLASSROOMS = "/classrooms",
    CLASSROOMS_CREATE = "/classrooms/create",

    BRIEFS_CREATE = "/trainer-workspace/briefs/create",
    BRIEFS_EDIT = "/trainer-workspace/briefs/[id]/edit",
    BRIEFS_DETAILS = "/trainer-workspace/briefs/[id]",
    BRIEFS_COLLABORATE = "/briefs/collaborate",
    BRIEFS_EXPLORE = "/briefs/explore",

    PROFILE = "/profile",
    PROFILE_EDIT = "/profile/edit",
    ANNOUNCEMENTS = "/announcements",
    ADMIN = "/admin",
    ADMIN_PAGES = "/admin/pages",
    ADMIN_PAGES_CREATE = "/admin/pages/create",
    ADMIN_PAGES_DETAILS = "/admin/pages/[id]",
    ADMIN_PAGES_EDIT = "/admin/pages/[id]/edit",
    ADMIN_ANNOUNCEMENTS = "/admin/announcements",
    ADMIN_ANNOUNCEMENTS_CREATE = "/admin/announcements/create",
    ADMIN_ANNOUNCEMENTS_DETAILS = "/admin/announcements/[id]",
    ADMIN_ANNOUNCEMENTS_EDIT = "/admin/announcements/[id]/edit",
    LANGUAGES = "/admin/languages",
    LANGUAGES_CREATE = "/admin/languages/create",
    LANGUAGES_DETAILS = "/admin/languages/[id]",
    LANGUAGES_EDIT = "/admin/languages/[id]/edit",
    TAGS = "/admin/tags",
    TAGS_CREATE = "/admin/tags/create",
    TAGS_DETAILS = "/admin/tags/[id]",
    TAGS_EDIT = "/admin/tags/[id]/edit",
    CATEGORIES = "/admin/categories",
    CATEGORIES_CREATE = "/admin/categories/create",
    CATEGORIES_DETAILS = "/admin/categories/[id]",
    CATEGORIES_EDIT = "/admin/categories/[id]/edit",
    STATISTICS = "/admin/statistics",
    CERTIFICATION_ISSUERS = "/admin/certification-issuers",
    CERTIFICATION_ISSUERS_CREATE = "/admin/certification-issuers/create",
    CERTIFICATION_ISSUERS_DETAILS = "/admin/certification-issuers/[id]",
    CERTIFICATION_ISSUERS_EDIT = "/admin/certification-issuers/[id]/edit",

    COOKIE_POLICY = "/cookie-policy",
    COOKIE_PREFERENCES = "/cookie-policy/preferences",
    REGISTRATION = "/registration",

    /**
     * Follow-ups list page
     */
    FOLLOW_UPS_LIST = "/follow-ups",
    FOLLOW_UPS_CREATE = "/follow-ups/create",
    FOLLOW_UPS_DETAILS = "/follow-ups/[followUpId]",
    FOLLOW_UPS_EDIT = "/follow-ups/[followUpId]/edit",

    /**
     * Mission creation page
     */
    MISSION_CREATE = "/mission/create",

    FRAMEWORKS = "/frameworks",

    OLD_CLASSROOM_BRIEFS_DETAILS = "/briefs/[briefId]",

    /**
     * Classroom space
     */
    CLASSROOMS_EDIT = "/classrooms/[classroomId]/edit",
    CLASSROOM_BRIEFS = "/classrooms/[classroomId]/briefs",
    CLASSROOM_BRIEFS_CREATE = "/classrooms/[classroomId]/briefs/create",
    CLASSROOM_BRIEFS_EDIT = "/classrooms/[classroomId]/briefs/[id]/edit",
    CLASSROOM_BRIEFS_DETAILS = "/classrooms/[classroomId]/briefs/[id]",
    CLASSROOM_BRIEFS_ASSIGN = "/classrooms/[classroomId]/briefs/[id]/assign",
    CLASSROOM_BRIEFS_GROUP_ASSIGN = "/classrooms/[classroomId]/briefs/[id]/group-assign",
    CLASSROOM_RESOURCES = "/classrooms/[classroomId]/resources",
    CLASSROOM_DASHBOARD = "/classrooms/[classroomId]/dashboard",
    CLASSROOMS_LEARNERS = "/classrooms/[classroomId]/learners",

    CLASSROOM_AGENDA = "/classrooms/[classroomId]/agenda",
    CLASSROOM_AGENDA_SCHEDULE = "/classrooms/[classroomId]/agenda/schedule",

    CLASSROOM_WORKSPACES = "/classrooms/[classroomId]/workspaces",

    CLASSROOM_WORKSPACES_REFLECTIVE_ANALYSIS_DETAILS = "/classrooms/[classroomId]/workspaces/reflective-analyses/[reflectiveAnalysisId]",

    CLASSROOMS_STATISTICS = "/classrooms/[classroomId]/statistics",
    CLASSROOM_LEARNER_PROGRESSION = "/classrooms/[classroomId]/progression",

    /**
     * Trainer space
     */
    TRAINER_WORKSPACE_BRIEFS = "/trainer-workspace/briefs",
    TRAINER_WORKSPACE_FRAMEWORKS = "/trainer-workspace/frameworks",
    TRAINER_WORKSPACE_PROFESSIONAL_SITUATION = "/trainer-workspace/professional-situations",
    TRAINER_WORKSPACE_PROFESSIONAL_SITUATION_CREATE = "/trainer-workspace/professional-situations/create",
    TRAINER_WORKSPACE_PROFESSIONAL_SITUATION_EDIT = "/trainer-workspace/professional-situations/[id]/edit",

    PAGE = "/pages/[pageUUID]",

    MY_WORKSPACE = "/my-workspace",
    MY_WORKSPACE_ASSIGNMENT = "/my-workspace/[assignmentId]",

    WORKSPACES = "/workspaces",
    WORKSPACES_REFLECTIVE_ANALYSIS_DETAILS = "/workspaces/reflective-analyses/[reflectiveAnalysisId]",

    LEARNERS = "/learners",

    NOTIFICATION_CALLBACK = "/notifications",

    ADMIN_BRIEFS = "/admin/briefs",
    ADMIN_BRIEFS_DETAILS = "/admin/briefs/[id]",

    ADMIN_FRAMEWORKS = "/admin/frameworks",
    ADMIN_FRAMEWORKS_CREATE = "/admin/frameworks/create",
    ADMIN_FRAMEWORKS_DETAILS = "/admin/frameworks/[id]",

    ADMIN_SKILLS = "/admin/skills",
    ADMIN_SKILLS_DETAILS = "/admin/skills/[id]",

    ADMIN_SKILL_DOMAINS = "/admin/skill-domains",
    ADMIN_SKILL_DOMAINS_DETAILS = "/admin/skill-domains/[id]",

    ADMIN_SKILL_BLOCKS = "/admin/skill-blocks",
    ADMIN_SKILL_BLOCKS_DETAILS = "/admin/skill-blocks/[id]",

    TRAINING_TEMPLATES = "/admin/training-templates",
    TRAINING_TEMPLATES_CREATE = "/admin/training-templates/create",
    TRAINING_TEMPLATES_EDIT = "/admin/training-templates/[id]/edit",
}

export default Route;
